module.exports = __webpack_public_path__ + "static/media/samfm.54ff32e6.jpg";